/* import __COLOCATED_TEMPLATE__ from './hold-and-assign.hbs'; */
/* RESPONSIBLE TEAM: team-workflows */
import Component from '@glimmer/component';
import type HoldAndAssign from 'embercom/models/operator/visual-builder/step/hold-and-assign';
import type EditorState from 'embercom/objects/workflows/graph-editor/editor-state';

interface Arguments {
  step: HoldAndAssign;
  editorState: EditorState;
  readOnly: boolean;
  isTemplatePreview: boolean;
}

export default class HoldAndAssignTerminal extends Component<Arguments> {
  get shouldShowError() {
    return this.args.editorState.shouldShowValidations && !this.args.step.validations.isValid;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::HoldAndAssign': typeof HoldAndAssignTerminal;
    'workflows/graph-editor/node-items/steps/hold-and-assign': typeof HoldAndAssignTerminal;
  }
}
